import React from 'react'
import GraphFilterComponent from './GraphFilterComponent'

function GraphComponent() {
  return (
    <>
        <GraphFilterComponent/>
    </>
  )
}

export default GraphComponent